
import { Component, OnInit } from '@angular/core';
import { DevExtremeModule } from 'devextreme-angular';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { User } from 'src/app/core/model/user';
import { DialogService } from 'src/app/shared/dialog.service';
import { UserDetailDialogComponent } from '../user-detail-dialog/user-detail-dialog.component';
import { ZoneZipCode } from 'src/app/core/model/zone-zip-code';
import { ZoneZipDialogComponent } from '../zone-zip-dialog/zone-zip-dialog.component';

@Component({
    selector: 'app-zone-zip-overview',
    standalone: true,
    templateUrl: './zone-zip-overview.component.html',
    styleUrls: ['./zone-zip-overview.component.scss'],
    imports: [DevExtremeModule]
})
export class ZoneZipOverviewComponent implements OnInit {
    zips: ZoneZipCode[];
    showAll: boolean = false;

    constructor(private uow: CdrUnitOfWork, private dialogService: DialogService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.zips = await this.uow.getZipCodes(this.showAll);
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        await this.getData();
    }


    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                }
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                }
            }
        );
    }

    async rowDoubleClick(e) {
        await this.open(e.data);
    }

    async open(zip: ZoneZipCode) {
        const dialogRef = this.dialogService.open(ZoneZipDialogComponent);
        dialogRef.instance.zip = zip;
        const results = await dialogRef.instance.show();

        if (results.success) {
            await this.uow.commit();
            await this.getData();
        } else this.uow.rollback();
        this.dialogService.close(dialogRef);
    }
}
